var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('van-overlay', {
    attrs: {
      "class-name": "dialog",
      "show": _vm.value,
      "z-index": "999"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_c('div', {
    staticClass: "wrapper",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('p', [_vm._v(_vm._s(_vm.title))]), _c('img', {
    staticClass: "close_icon",
    attrs: {
      "src": require("@/assets/image/ic_xxxxxx.png"),
      "alt": ""
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.handleCancel();
      }
    }
  })]), _c('div', {
    staticClass: "hint"
  }, [_vm.hint === '' ? _c('div', {
    staticClass: "toast"
  }, [_c('span', [_vm._v("温馨提示: 切勿相信")]), _vm._v("微信或短信到账通知信息！！！请务必查看"), _c('span', [_vm._v("实时收款记录")]), _vm._v(" 确认收到款后,再进行确认打币,不仔细确认 "), _c('span', [_vm._v("实时收款信息")]), _vm._v(" 随意打币所造成的"), _c('span', [_vm._v("损失")]), _vm._v(",自行承担！！！ ")]) : _c('div', [_vm._v(" " + _vm._s(_vm.hint) + " ")])]), _vm._t("content"), _vm._t("footer")], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };